import React, {FormEvent, useState} from 'react';
import axios from "axios";
import {Subsidiary} from "../../types";

type Step3Props = {
    step: number,
    setStep: (step: number) => void,
    maxStep: number,
    subsidiaries: Subsidiary[],
    enable: boolean,
    setVisible: (visible: boolean) => void,
    referer: string
}
function Step3({step, setStep, maxStep, subsidiaries, setVisible}: Step3Props) {

    const [selectSubsidiary, setSelectSubsidiary] = useState('')
    const onSubmitClick = (event: React.MouseEvent<HTMLButtonElement>|FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (selectSubsidiary) {
            axios.get('/local/ajax/subsidiary.php?subsidiary=' + selectSubsidiary)
                .then(response => {
                    if (response.data === 'reload') {
                        window.location.reload();
                    } else if (response.data === 'success') {
                        setStep(0)
                        setVisible(false)
                    }
                })
        }
    }

    return (
        <div className="age-access-inner">
            <div className="age-access__text">
                <h1 className="text-dark font-medium dark:font-light text-xl dark:text-textDarkLightGray mb-5 ">
                    {step} / {maxStep} </h1>
                <h1 className="text-dark font-medium dark:font-extralight text-lg dark:text-textDarkLightGray
                             mb-4 text-center">
                    Какой филиал ближе к Вам?</h1>
            </div>
            <form onSubmit={onSubmitClick} method="GET" id="modal-subsidiary-form">
                <div className="flex flex-col">
                    {subsidiaries.map((subsidiary, key) => (
                        <div key={key} className={`mt-3 md:p-5 p-3 rounded-xl text-textLight dark:text-textDark dark:bg-lightGrayBg border border-grey-line-order cursor-pointer
                                ${selectSubsidiary === subsidiary.LID ? 'dark:border-white border-light-red' : 'dark:border-0'} `}
                             onClick={() => setSelectSubsidiary(subsidiary.LID)}
                        >
                            {subsidiary.NAME}
                        </div>
                    ))}
                    <div className={`mt-3 md:p-5 p-3 rounded-xl text-textLight dark:text-textDark dark:bg-lightGrayBg border border-grey-line-order cursor-pointer
                                ${selectSubsidiary === 'CUSTOM' ? 'dark:border-white border-light-red' : 'dark:border-0'} `}
                         onClick={() => setSelectSubsidiary('CUSTOM')}
                    >
                        Другой регион
                    </div>

                </div>
                <div className="age-access__buttons flex flex-row justify-center mt-5">
                    <button disabled={selectSubsidiary === ''}
                            type="submit"
                            className="text-center md:px-9 px-4 py-2 block w-2/5 osh-prmBtn"
                            onClick={onSubmitClick}
                    >
                        Выбрать
                    </button>
                </div>
            </form>
        </div>
    );
}

export default Step3;